import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";
import { Trophy } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, pw, name);
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 grid-bg">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-primary-accent flex items-center justify-center">
            <Trophy size={22} />
          </div>
          <div className="font-display text-2xl tracking-wider">JINXING SPORTS</div>
        </div>
        <div className="label-tag mb-2">Sign Up</div>
        <h2 className="font-display text-4xl uppercase mb-8">Join the league</h2>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-tag block mb-2">Name</label>
            <input
              data-testid="register-name-input"
              type="text" value={name} onChange={(e) => setName(e.target.value)}
              required placeholder="Jane Doe"
              className="w-full bg-zinc-950 border border-zinc-800 px-4 py-3 focus:border-primary-accent focus:outline-none"
            />
          </div>
          <div>
            <label className="label-tag block mb-2">Email</label>
            <input
              data-testid="register-email-input"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required placeholder="you@example.com"
              className="w-full bg-zinc-950 border border-zinc-800 px-4 py-3 focus:border-primary-accent focus:outline-none"
            />
          </div>
          <div>
            <label className="label-tag block mb-2">Password</label>
            <input
              data-testid="register-password-input"
              type="password" value={pw} onChange={(e) => setPw(e.target.value)}
              required minLength={6} placeholder="••••••••"
              className="w-full bg-zinc-950 border border-zinc-800 px-4 py-3 focus:border-primary-accent focus:outline-none"
            />
          </div>
          <button
            data-testid="register-submit-btn"
            type="submit" disabled={busy}
            className="w-full bg-primary-accent text-white font-display tracking-widest py-3 text-lg uppercase disabled:opacity-50"
          >
            {busy ? "Creating..." : "Create Account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-zinc-400 text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-primary-accent uppercase tracking-widest text-xs" data-testid="login-link">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
